"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_ejs_1 = require("./form.ejs");
var html_ejs_1 = require("./html.ejs");
exports.default = { form: form_ejs_1.default, html: html_ejs_1.default };
